import React, { Component } from "react";
    import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
    import { faHome } from "@fortawesome/free-solid-svg-icons";
    import { Breadcrumb } from "@themesberg/react-bootstrap";

    import { GetData as t } from "../../lingual";
    import { Routes } from "../../routes";
    import { Card } from "@themesberg/react-bootstrap";
    import "./Client.less";
    import {
      notification, Form,
      Input,
      Button,
      Switch,
      Spin,
      Upload,
      
    } from "antd";
    import LocalStorageService from "../../services/storage/LocalStorageService";import { UploadOutlined } from "@ant-design/icons";import { BASE_URL } from "../../config";
    
    import axios from "../../axios";
    
    import { logout } from "../../utils";

    
    class ClientAddEdit extends Component {
    
      constructor(props) {
        super(props);

        const localStorageService = LocalStorageService.getService();

        const token = localStorageService.getAccessToken();
        const props1 = {
              name: "image",
              action: BASE_URL + "/uploadImage",
              headers: {
                authorization: "authorization-text",
                "x-access-token": token,
              },
            };

        this.state = {
          title: t("client"),
          description: t("add_new_client"),
          columns: [],
          values: {status:true},
          gotData: false,
          active: true,
          submitButtonName:t("submit"),
          uploadprops: props1,uploadvaluelogo: "",
        }
        
        this.onValuesChange = this.onValuesChange.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.onFinishFailed = this.onFinishFailed.bind(this);
        this.switchOnChange = this.switchOnChange.bind(this);

        this.uploadOnChangelogo = this.uploadOnChangelogo.bind(this);

      }

      uploadOnChangelogo = (value) => {
            console.log(this.state.uploadvaluelogo,"logo");
            this.setState({ uploadvaluelogo: "" })
          };
      openNotificationWithIcon = (type, message, description) => {
        notification[type]({
          message: message,
          description: description,
        });
      };
      formRef = React.createRef();
      onValuesChange = (d) => {
        
      }
    
      onFinish = (values) => {
        
        values.status = this.state.active?1:0;
        
    
        console.log(this.state.uploadvaluelogo);
        if (this.state.uploadvaluelogo!=""){
          values.logo =this.state.uploadvaluelogo;
        }else {
        values.logo = values.logo.file.response.filename;}
        
        let path="client";
        if (this.props.match.params.id==="new"){
          
        
        axios.post(path, values)
          .then(res => {
            console.log(res);
            if (res.status === 200) {
              if (res.data.error) {
    
                this.openNotificationWithIcon("warning",t("client"), res.data.error.message)
              } else {
                this.cancelFun();
                this.openNotificationWithIcon("success",t("client"), t("data_added_successfully"));
              }
            }
          }).catch(error => {
            console.log(error)
            if (error.response && error.response.status === 401) {
              this.openNotificationWithIcon("warning",t("invalid_login"),t("please_try_again"));
              logout();
              this.props.history.push("/login");
            } else {
              this.openNotificationWithIcon("warning",t("something_went_wrong") , t("please_contact_adminstrator"))
            }
          })
        }else {
          path += "/"+this.props.match.params.id;
          axios.put(path, values)
          .then(res => {
            console.log(res);
            if (res.status === 200) {
              if (res.data.error) {
    
                this.openNotificationWithIcon("warning", "Client", res.data.error.message)
              } else {
                this.cancelFun();
                this.openNotificationWithIcon("success", "Client", t("data_updated_successfully"));
              }
            }
          }).catch(error => {
            console.log(error)
            if (error.response && error.response.status === 401) {
              this.openNotificationWithIcon("warning",t("invalid_login"),t("please_try_again"));
              logout();
              this.props.history.push("/login");
            } else {
              this.openNotificationWithIcon("warning",t("something_went_wrong") , t("please_contact_adminstrator"))
            }
          })
    
        }
      };
      onFinishFailed = (values) => {
      };
    
      switchOnChange = (checked) => {
        this.setState({ active: checked })
      };
      cancelFun = () => {
        // {pathname:this.props.history.goBack,state:this.props.location.state}
        this.props.history.push({
          pathname: Routes.Client.pathview,
          state: this.props.location.state,
        });
      };
    
      componentDidMount(prevProps) {
        
        if (this.props.match.params.id!=="new"){
          this.setState({
            description: t("edit_client"),
            submitButtonName: t("update"),
          });

          let path = "client/"+this.props.match.params.id;
          axios
            .get(path)
            .then((res) => {
              console.log(res);
              if (res.status === 200) {
                if (res.data.error) {
                  
                  this.openNotificationWithIcon(
                    "warning",
                    t("role_permission"),
                    res.data.error.message
                  );
                } else {
                  console.log(res.data.data);
                  this.setState({
                    values: res.data.data,
                    
                    gotData: true,
                    active: res.data.data.status,});
            this.setState({ uploadvaluelogo: res.data.data.logo });
                  
                }
              }
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) {
                this.openNotificationWithIcon(
                  "warning",
                  t("invalid_login"),
                  t("please_try_again")
                );
                logout();
                this.props.history.push("/login");
              } else {
                this.openNotificationWithIcon(
                  "warning",
                  t("something_went_wrong"),
                  t("please_contact_adminstrator")
                );
              }
            });
        }else {
          this.setState({ gotData: true });
        }
      }
    
      render() {return (
          <>
            <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-xl-0">
                <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                  <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                  <Breadcrumb.Item active>{this.state.title}</Breadcrumb.Item>
                </Breadcrumb>
                <h4>{this.state.title}</h4>
                <p className="mb-0">
                {this.state.description}
                </p>
              </div>
            </div>
            <Card border="light" className="shadow-sm mb-4">
              <Card.Body className="pb-0">
                {this.state.gotData ? (
                  <Form
                labelCol={{
                  span: 4,
                }}
                wrapperCol={{
                  span: 14,
                }}
                layout="horizontal"
                initialValues={this.state.values}
                onValuesChange={this.onValuesChange}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                size="default"
                ref={this.formRef}
              >
              <Form.Item
    label= {t("id")}
    key="100"
    name="client_id"
  >
    <Input
      placeholder= {t("auto_incerment")}
      disabled="true"
    />
  </Form.Item>
  <Form.Item
                  label= {t("client__name")}
                  key="0"
                  name="client_name"
                  rules={
                    [
                      {required : 1,          
                          message: t("please_enter_a_client_name")}

                  ]
                }
                >
                  <Input
                    placeholder= {t("enter_a_client_name")}
                    disabled=""
                  />
                </Form.Item><Form.Item
                  label= {t("brand_name")}
                  key="1"
                  name="brand_name"
                  rules={
                    [
                      {required : 1,          
                          message: t("please_enter_a_brand_name")}

                  ]
                }
                >
                  <Input
                    placeholder= {t("enter_a_brand_name")}
                    disabled=""
                  />
                </Form.Item><Form.Item
        label= {t("logo")}
        key="2"
        name="logo"
        rules={
          [
            {required : 1,
            message: t("please_enter_a_logo")}
        ]
      }
      >
      <Upload 
      name={this.state.uploadprops.name}
      action={this.state.uploadprops.action}
      header={this.state.uploadprops.headers}
      onChange={this.uploadOnChangelogo}
      >
          <Button icon={<UploadOutlined />}>{t("click_to_upload")}</Button>
        </Upload>
      </Form.Item><Form.Item
                  label= {t("brand_url")}
                  key="3"
                  name="brand_url"
                  rules={
                    [
                      {required : 1,          
                          message: t("please_enter_a_brand_url")}

                  ]
                }
                >
                  <Input
                    placeholder= {t("enter_a_brand_url")}
                    disabled=""
                  />
                </Form.Item>
                <Form.Item
                      
                      label={t("active")}
                      key="101"
                    >
                      <Switch
                        name="status"
                        key="101"
                        onChange={this.switchOnChange}
                        defaultChecked={this.state.values.status}
                      />
                    </Form.Item>
    <Form.Item justify="center">
    <Button
      className="paddme"
      onClick={this.cancelFun}
    >
      {t("cancel")}
    </Button>

    <Button type="primary" htmlType="submit">
      {this.state.submitButtonName}
    </Button>
  </Form.Item>

              </Form>
                ) : (<div className="loadingpsin">
                  <Spin />
                </div>)}
              </Card.Body>
            </Card>
          </>
        );
      }
    }
    
    
    export default ClientAddEdit;
    
    